import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAnalyticsPagePayload, trackEvent } from '../lib/analytics';

const AnalyticsPageView = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent('page_view', getAnalyticsPagePayload());
  }, [location]);

  return null;
};

export default AnalyticsPageView;
